import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';

Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);

import postGrid from './alpine/post-grid.js';
import resourceTypeFilter from './alpine/resource-type-filter.js';
import topicFilter from './alpine/topic-filter.js';
import pressTypeFilter from './alpine/resource-type-filter.js';
import pntUI from './alpine/pnt-ui.js';
import contactSupportInterface from './alpine/contact-support-interface.js';
import legalPicker from './alpine/legal-picker.js';
import legalSection from './alpine/legal-section.js';
import carousel from './alpine/carousel.js';
import topicSubtopicFilter from './alpine/topic-subtopic-filter.js';
import typeFilter from './alpine/type-filter.js';
import postCards from './alpine/post-cards.js';
import filterGroup from './alpine/filter-group.js';
import opportunityFilter from './alpine/opportunity-filter.js';
import opportunityContent from './alpine/opportunity-content.js';
import opportunityContentSlide from './alpine/opportunity-content-slide.js';
import opportunityModal from './alpine/opportunity-modal.js';
import headerSpace from './alpine/header-space.js';
import comeetPluginFilter from './alpine/comeet-plugin-filter.js';
import partnerOnboarding from './alpine/partner-onboarding.js';

Alpine.data('postGrid', postGrid);
Alpine.data('resourceTypeFilter', resourceTypeFilter);
Alpine.data('topicFilter', topicFilter);
Alpine.data('pressTypeFilter', pressTypeFilter);
Alpine.data('pntUI', pntUI);
Alpine.data('contactSupportInterface', contactSupportInterface);
Alpine.data('legalPicker', legalPicker);
Alpine.data('legalSection', legalSection);
Alpine.data('carousel', carousel);
Alpine.data('topicSubtopicFilter', topicSubtopicFilter);
Alpine.data('typeFilter', typeFilter);
Alpine.data('postCards', postCards);
Alpine.data('filterGroup', filterGroup);
Alpine.data('opportunityFilter', opportunityFilter);
Alpine.data('opportunityContent', opportunityContent);
Alpine.data('opportunityContentSlide', opportunityContentSlide);
Alpine.data('opportunityModal', opportunityModal);
Alpine.data('headerSpace', headerSpace);
Alpine.data('comeetPluginFilter', comeetPluginFilter);
Alpine.data('partnerOnboarding', partnerOnboarding);
window.Alpine = Alpine;
ready( () => Alpine.start() ); // Needs to be _after_ registering any extension code

function ready(fn) {
	if (document.readyState != 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}
